<template>
  <div @click="$emit('click')" class="card-news">
    <div class="card-news_photo">
      <img :src="photo" v-if="photo" alt="">
    </div>
    <div class="card-news_info">
      <div class="card-news_title">
        <p>{{ title }}</p>
      </div>
      <div class="card-news_excerpt">
        <p>{{ excerpt }}</p>
      </div>
      <div class="card-news_tools">
        <span class="card-news_date">{{ date }}</span>
        <button class="card-news_link">
          Подробнее
          <strong>
            <font-awesome-icon :icon="['fas', 'chevron-right']" />
          </strong>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    photo: String,
    excerpt: String,
    date: String,
  },
}
</script>

<style lang="less">
.card-news {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border-radius: 30px;
  box-shadow: 0 16px 46px -20px rgba(0, 0, 0, .15);
  overflow: hidden;
  cursor: pointer;

  &_photo {
    width: 100%;
    //height: 260px;
    background-color: #F6F6F6;
    background-image: url('/news.svg');
    background-size: 79px 79px;
    background-position: center;
    background-repeat: no-repeat;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
  }

  &_info {
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: white;
    padding: 28px 20px 17px 28px;
  }

  &_title {
    font-family: 'Roboto Slab', Arial, sans-serif;
    font-weight: 500;
    font-size: 20px;
    margin-bottom: 12px;
    min-height: 40px;
  }

  &_excerpt {
    width: 100%;
    height: 56px;
    font-family: 'Roboto', Arial, sans-serif;
    font-weight: 300;
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 9px;
    overflow: hidden;
  }

  &_tools {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &_date {
    font-family: 'Roboto', Arial, sans-serif;
    font-weight: 300;
    font-size: 14px;
    color: @news--date-color;
  }

  &_link {
    display: flex;
    align-items: center;
    background-color: transparent;
    font-family: 'Roboto', Arial, sans-serif;
    font-size: 14px;
    color: black;
    padding: 0;
    border: none;
    cursor: pointer;

    strong {
      width: 45px;
      height: 45px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: @color-primary;
      background: @gradient-primary;
      font-size: 14px;
      padding-left: 3px;
      color: white;
      border: 8px solid #FBFBFB;
      border-radius: 50%;
      margin-left: 9px;

      @media screen and (max-width: 1200px) {
        width: 36px;
        height: 36px;
        border-width: 7px;
        font-size: 12px;
        margin-left: 6px;
      }
    }
  }
}
</style>
